"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const options = {
    status: {
        0: '下架',
        1: '上架'
    }
};
exports.default = options;
